import styled from 'styled-components'

interface InputProps {
  type: string
  name: string
  placeholder: string
  value?: any
  onChange?: (event: any) => void
  onFocus?: (event: any) => void
  readonly?: true
  onBlur?: (event: any) => void
  min?: string
}

const InputContainer = styled.div`
  /* width: 100%; */

  /* @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 90%;
  } */
`
const InputWrapper = styled.input`
  height: 50px;
  width: 90.5%;
  border-radius: 10px;
  border: 1px solid #6e7191;
  outline: none;
  padding-left: 30px;
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-size: ${({ theme }) => theme.fontSize.x2};

  @media (max-width: ${({ theme }) => theme.responsive.laptop}) {
    width: 100%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.ipad}) {
    width: 93.2%;
  }
  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 89.5%;
  }
`

const FormInput = ({
  type,
  name,
  placeholder,
  value,
  onChange,
  onFocus,
  onBlur,
  readonly,
  min,
}: InputProps) => {
  return (
    <InputContainer>
      <InputWrapper
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        readOnly={readonly}
        onBlur={onBlur}
        min={min}
      />
    </InputContainer>
  )
}
const QuicksaveInput = styled(InputWrapper)`
  width: -webkit-fill-available;
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.x5};
  color: ${({ theme }) => theme.colors.gray};
  padding-left: 16px;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.cyanBlue};
  box-sizing: border-box;
  border-radius: 4px;
  height: 48px;
  &:focus {
    border: 1px solid blue;
  }
`
export const Input = styled.input`
  background: ${({ theme }) => theme.colors.white};
  width: 484px;
  border: 1px solid ${({ theme }) => theme.colors.cyanBlue};
  box-sizing: border-box;
  border-radius: 4px;
  height: 48px;
`
const InputLogin = styled(InputWrapper)`
  font-style: normal;
  font-weight: 500;
  font-size: ${({ theme }) => theme.fontSize.x5};
  color: ${({ theme }) => theme.colors.gray};
  padding-left: 16px;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  border: 1px solid ${({ theme }) => theme.colors.cyanBlue};
  box-sizing: border-box;
  border-radius: 4px;
  height: 48px;

  &:focus {
    border: 1px solid blue;
  }
`

const CopyInput = styled(InputWrapper)`
  background: rgba(87, 102, 255, 0.1);
  border-radius: 6px;
  height: 28px;
  width: 100%;
  padding-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${({ theme }) => theme.colors.secondPrimary};
  border: none;
`

const InvestmentInput = styled(CopyInput)`
  width: 100%;
  height: 45px;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    border: 1px solid #00327c;
  }
  &:outline {
    border: 1px solid #00327c;
  }
`

const WithdrawInput = styled(InvestmentInput)`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  border: 1px solid #d7dce0;
  border-radius: 6px;
  font-style: normal;
  padding-left: 20px;
  font-weight: 600;
  font-size: ${({ theme }) => theme.fontSize.x5};
  line-height: 16px;
  color: ${({ theme }) => theme.colors.navyBlue};
`

const PinInput = styled(WithdrawInput)`
  width: 50%;
`

export {
  FormInput,
  QuicksaveInput,
  CopyInput,
  InvestmentInput,
  WithdrawInput,
  PinInput,
  InputLogin,
}
